import React from "react";
import { useTranslation } from "react-i18next";
import { Select, Card, Typography } from "antd";
import "./SettingsPage.css";

const { Option } = Select;
const { Title } = Typography;

const SettingsPage = () => {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="settings-container">
      <Card className="settings-card">
        <Title level={2}>{t("settings")}</Title>
        <div className="language-selector">
          <label>{t("selectLanguage")}: </label>
          <Select 
            defaultValue={i18n.language} 
            style={{ width: 200 }} 
            onChange={changeLanguage}
          >
            <Option value="en">English</Option>
            <Option value="ur">اردو</Option>
            <Option value="ar">العربية</Option>
          </Select>
        </div>
      </Card>
    </div>
  );
};

export default SettingsPage;
